import { COUNTRY_CODES, COUNTRY_DETAILS, DEFAULT_COUNTRY_CODE } from '../constants/country'

export const getCountryCode = (country) => country?.code || DEFAULT_COUNTRY_CODE

export const isUruguay = (country) => getCountryCode(country) === COUNTRY_CODES.URUGUAY

export const getCountryDetails = (country) => (
  COUNTRY_DETAILS[getCountryCode(country)] || COUNTRY_DETAILS[DEFAULT_COUNTRY_CODE]
)

export const getMapboxCountry = (country) => (
  country?.mapboxCountry || getCountryDetails(country).mapboxCountry
)
